import { Card, Grid } from '@material-ui/core'
import { useState } from 'react'
import {
  Button,
  EditButton,
  Labeled,
  NumberField,
  ReferenceField,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TopToolbar,
  useLoading,
  usePermissions,
} from 'react-admin'
import { Redirect } from 'react-router-dom'

import FeasibilityStatButton from '../../components/Common/FeasibilityStatButton'
import { hasPermission, Permissions } from '../../Permissions'
import { LoadStops } from '../Common/Loads'
import { CustomBooleanField, CustomLinkifiedField } from '../Fields'

const CloneCustomLoadButton = ({ record, disabled }: any) => {
  const [redirect, setRedirect] = useState(false)

  return redirect ? (
    <Redirect
      to={{
        pathname: '/custom-loads/create',
        state: {
          customLoad: record,
        },
      }}
      push={true}
    />
  ) : (
    <Button
      variant="contained"
      color="primary"
      label="Clone Custom Load"
      disabled={disabled}
      onClick={() => setRedirect(true)}
    />
  )
}

const CustomLoadShowActions = ({ basePath, data }: any) => {
  const isLoading = useLoading()
  const { permissions } = usePermissions()
  if (!data || !permissions) return null

  const canCreateCustomLoad = hasPermission(permissions, Permissions.AddCustomLoad)
  const canEditCustomLoad = hasPermission(permissions, Permissions.ChangeCustomLoad)
  const canChangeFeasibilityStat = hasPermission(permissions, Permissions.CanChangeFeasibilityStat)

  return (
    <TopToolbar>
      <Grid container direction="row" spacing={2} justifyContent="flex-start">
        {canCreateCustomLoad && (
          <Grid item>
            <CloneCustomLoadButton record={data} disabled={isLoading} />
          </Grid>
        )}

        {canChangeFeasibilityStat && (
          <Grid item>
            <FeasibilityStatButton
              kind="custom_load"
              id={data.id}
              disabled={isLoading}
              label="Start Feasibility Check"
            />
          </Grid>
        )}
        {canEditCustomLoad && (
          <Grid item>
            <EditButton basePath={basePath} record={data} />
          </Grid>
        )}
      </Grid>
    </TopToolbar>
  )
}

const CustomLoadShow = (props: any) => {
  return (
    <Show actions={<CustomLoadShowActions />} {...props}>
      <Grid container direction="column" spacing={3} alignItems="baseline" justifyContent="flex-start">
        <Grid item>
          <Card style={{ marginTop: '20px', paddingBottom: '20px' }}>
            <TabbedShowLayout record={props.record}>
              <Tab label="Load information">
                <TextField source="id" />
                <CustomBooleanField source="show_in_search" label="Visible in Search" />
                <CustomBooleanField source="ghost_load" label="Ghost Load" />
                <TextField source="external_source" />
                <TextField source="virtual_source" />
                <Labeled label="Broker">
                  <ReferenceField
                    basePath="/brokers"
                    record={props.record}
                    source="broker.id"
                    reference="brokers"
                    link="show"
                  >
                    <TextField source="name" />
                  </ReferenceField>
                </Labeled>
                <TextField source="external_source_id" label="Source Id" />
                <TextField source="external_source_human_id" label="Broker load ID" />
                <TextField source="contact.name" label="Contact" />
                <TextField source="contact.phone" label="Contact Phone" />
                <TextField source="contact.email" label="Contact Email" />
                <TextField source="company_name" />
                <CustomLinkifiedField source="internal_notes" label="Internal notes" record={props.record} />
                <LoadStops source="load_stops" record={props.record} />
                <CustomBooleanField source="standard_book" />
                <CustomBooleanField source="instant_book" />
                <CustomBooleanField source="bid_book" />
                <TextField source="trip_rate" />
                <NumberField source="trip_distance_mi" />
              </Tab>
              <Tab label="Equipment">
                <TextField source="equipment" />
                <TextField source="equipment_detail" />
                <TextField source="truck_full_load" />
                <NumberField source="truck_weight_lb" />
                <NumberField source="truck_length_ft" />
              </Tab>
              <Tab label="Misc" path="misc">
                <NumberField source="trip_stops" />
                <TextField source="comment" />
                <TextField source="origin_location" />
                <TextField source="dest_location" />
              </Tab>
            </TabbedShowLayout>
          </Card>
        </Grid>
      </Grid>
    </Show>
  )
}

export default CustomLoadShow
